import { API_HELPER } from '@/helpers/api.js';

const SATISFACTION_QUESTIONS_API = "SatisfactionQuestions";
const SATISFACTION_FORMS_API = "SatisfactionForms";

export const satisfactionQuestionsService = {
  getQuestions(queryParams) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, SATISFACTION_QUESTIONS_API]);
    
    const requestOptions = {
      method: 'GET',
      headers: {"Content-Type":"application/json"},
    };
    
    return API_HELPER.apiCall(url, queryParams, requestOptions);
  },
  
  submitAnswer(answers, reservationId = null, token = null) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, SATISFACTION_FORMS_API, "submit"]);
    
    const body = {
      reservationId: reservationId,
      answers: answers
    };
    
    // Adicionar token se fornecido
    if (token) {
      body.token = token;
    }
    
    const requestOptions = {
      method: 'POST',
      headers: {"Content-Type":"application/json"},
      body: JSON.stringify(body)
    };
    
    return API_HELPER.apiCall(url, null, requestOptions);
  }
};

